import { render } from "./SendAsEmail.vue?vue&type=template&id=73e1c5de"
import script from "./SendAsEmail.vue?vue&type=script&lang=js"
export * from "./SendAsEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__